import {SmartPrediction} from '../models/smart-prediction.entity';
import {TrackedUnit} from '../models/unit-tracking/tracked-unit.model';

export class TrackedUnitResponse {
  totalTrackedUnits = 0;
  trackedUnits: TrackedUnit[] = [];

  constructor(rawData: any[], totalTrackedUnits: number) {
    this.totalTrackedUnits = totalTrackedUnits;
    this.trackedUnits = rawData as TrackedUnit[];
  }
}
